// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")

// Advisory - Energy Billing
const EnergySurplus = (params) => {
  
  useEffect(() => { 
    
    document.title = "HELIAS - Asesoramiento: Excedente energético"     
    document.querySelector('meta[name="description"]').setAttribute("content", "¿Le estás regalando tu excedente energético a tu compañía eléctrica y no sabes que hacer?");

    console.log("Abro asesoramiento para el contrato de luz.")    

  });

  return (      
    <main className="no-background">

      <section id="welcome-01" className="step">
        <div className="content-wrapper">          
            
            <div className="vertical gap-02">
              
            { initialConfigCommonJS.existeSesion() ?     

              <>
                { Object.keys(params.objDatosDashboard.FVData ).length === 0 ?
                  <p key="mensajePersonalizado">Aunque no tengas paneles solares échale un ojo a esta información ya que puede que te anime a instalarlos si te lo estuvieras pensando.</p>
                :
                  [ params.objDatosDashboard.FVData.SolarWallet === "false" ?
                    [ params.objDatosDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value > 0?
                      <p key="mensajePersonalizado">A día de hoy <strong>le llevas regalados a tu compañía eléctrica {parseFloat(params.objDatosDashboard.SelfConsumptionAndSavingsData.CurrentMonthGivenAwayMoney.Value).toFixed(2)}€</strong>, échale un ojo urgentemente a lo siguiente para dejar de regalar el dinero.</p>            
                    :
                      <p key="mensajePersonalizado">Al tener paneles solares es muy probable que llegue un momento en el que empieces a regalarle el dinero a tu compañía ya que si vendes más que consumes ese excedente no te lo van a pagar.</p>
                    ]
                    :
                    <p key="mensajePersonalizado">Veo que ya tienes algún producto contratado para gestionar tu excedente, aun así échale un ojo a esta información por si te pudiera interesar.</p>            
                  ]
                }

                <p>Para aprovechar tu excedente puedes usar:</p>
                
                <ul className="default-list">              
                  { params.objDatosDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true" && params.objDatosDashboard.FVData.SolarWallet !== "true" ?
                    <>
                      <li className="success"><strong>Monedero solar o batería virtual:</strong> Funciona como una hucha...</li>
                      <ul className="default-list">
                        <li>Acumula toda la energía en € que no has aprovechado. Obviamente los € que acumules dependerán de la tarifa a la que te compren la energía (fija o indexada). A día de hoy suele salir más rentable tener tarifa fija, aunque al funcionar como "la bolsa", esto podría cambiar en determinados momentos.</li>
                        <li>No caduca y si por ejemplo en verano generas mucho, puedes usarlo para invierno.</li>
                        <li>Además te permite descontar la parte fija de la factura llegando a conseguir "facturas 0€", aunque para esto hay que tener un excedente considerable.</li>                  
                        <li>Este servicio no suele conllevar coste, aunque algunas compañías sí cobran por él y el precio ronda <strong> los 3€ + IVA al mes</strong>.</li>

                        { params.objDatosDashboard.FVData.FVSubsidy === "true" ?
                          <li className="error">CUIDADO EN TU CASO: Tienes subvención otorgada o solicitada. Si contratas este servicio recuerda que tu aprovechamiento energético bajará del 80% que es el mínimo (al interesarte ahora vender todo lo posible) y por tanto te retirarán la subvención al cabo como mucho de un año... así que si eres consciente de esto adelante con esta opción y si quieres mantener la subvención entonces olvídate de esta alternativa.</li>                    
                        :
                          <></>
                        }

                      </ul>
                    </>
                  :
                    <></>
                  }

                  { Object.keys(params.objDatosDashboard.BatteriesData ).length === 0 ?
                    <li className="success"><strong>Baterías físicas:</strong> Permiten almacenar la energía directamente, evitando que ésta se vuelque a la red. Aun así el coste suele ser alto y el tiempo de amortización largo. Como es complicado ver si está opción te interesa, puedes probar nuestro simulador y ver si es tu caso. Pulsa <a href="/Advisory/BatteriesInstallation" rel="noopener noreferrer" target="_self" className="link inline-link">aquí</a> para ir a nuestro simulador de baterías.</li> 
                    :
                    <></>
                  }
                </ul>
              </>
              :
                <>
                {/* INCLUIR CAMPOS ADICIONALES NECESARIOS PARA MOSTRAR CORRECTAMENTE LAS RECOMENDACIONES*/}
                <p>Si tienes paneles solares es muy probable que llegue un momento en el que empieces a regalarle el dinero a tu compañía ya que si vendes más que consumes ese excedente no te lo van a pagar.</p>
                <p>Para aprovechar tu excedente puedes usar:</p>
                <ul className="default-list">   
                  <li className="success"><strong>Monedero solar o batería virtual:</strong> Funciona como una hucha...</li>
                  <ul className="default-list">
                    <li>Acumula toda la energía en € que no has aprovechado. Obviamente los € que acumules dependerán de la tarifa a la que te compren la energía (fija o indexada). A día de hoy suele salir más rentable tener tarifa fija, aunque al funcionar como "la bolsa", esto podría cambiar en determinados momentos.</li>
                    <li>No caduca y si por ejemplo en verano generas mucho, puedes usarlo para invierno.</li>
                    <li>Además te permite descontar la parte fija de la factura llegando a conseguir "facturas 0€", aunque para esto hay que tener un excedente considerable.</li>                  
                    <li>Este servicio no suele conllevar coste, aunque algunas compañías sí cobran por él y el precio ronda <strong> los 3€ + IVA al mes</strong>.</li>   
                    <li className="error">ATENCIÓN: Contratar este servicio sólo se recomienda a la gente que ha decidido optar por la estrategia de "vender todo el excedente posible". Con esta estrategia es más que probable que tu aprovechamiento energético mínimo (% de energia que consumes con respecto a la que generas) sea inferior al 80%, y si tienes subvención solicitada o concedida es más que probable que te la rechacen o te la retiren ya que para tener derecho a ella el aprovechamiento energético debe ser al menos del 80% o superior. Si eres consciente de esto adelante con esta opción y si quieres mantener la subvención entonces olvídate de esta alternativa.</li>
                  </ul>
                  { initialConfigCommonJS.existeSesion() ?
                    <li className="success"><strong>Baterías físicas:</strong> Permiten almacenar la energía directamente, evitando que ésta se vuelque a la red. Aun así el coste suele ser alto y el tiempo de amortización largo. Como es complicado ver si está opción te interesa, puedes probar nuestro simulador y ver si es tu caso. Pulsa <a href="/Advisory/BatteriesInstallation" rel="noopener noreferrer" target="_self" className="link inline-link">aquí</a> para ir a nuestro simulador de baterías.</li> 
                  :
                    <li className="success"><strong>Baterías físicas:</strong> Permiten almacenar la energía directamente, evitando que ésta se vuelque a la red. Aun así el coste suele ser alto y el tiempo de amortización largo. Como es complicado ver si está opción te interesa, puedes probar nuestro simulador y ver si es tu caso. Pulsa <a href="/Asesoramiento/Baterias" rel="noopener noreferrer" target="_self" className="link inline-link">aquí</a> para ir a nuestro simulador de baterías.</li> 
                  }
                </ul>
                <p>Por último recuerda que una de las ventajas de tener una suscripción en Helias es que toda esta información la comprobaré contínuamente para decirte si tu subvención peligra o si le estás regalando tu excedente a tu comercializadora y cuál de estas opciones es la que más te interesa.</p>
                </>
            }
              
            </div>    
          
        </div>        

      </section>

    </main>
  )
}

export default EnergySurplus